import { createPublicClient, http, defineChain } from 'viem';
import { config } from '@/config';

const hepChain = defineChain({
  id: config.blockchain.chainId,
  name: config.blockchain.nativeCurrencyName,
  nativeCurrency: { name: config.blockchain.nativeCurrencyName, symbol: config.blockchain.nativeCurrencySymbol, decimals: 2 },
  rpcUrls: {
    default: { http: [config.blockchain.rpcUrl] },
    public:  { http: [config.blockchain.rpcUrl] },
  },
});

export const explorerClient = createPublicClient({
  chain: hepChain,
  transport: http(config.blockchain.rpcUrl),
});

// HEP raw bigint (2 decimals) → "12.34 HEP"
export function formatHep(raw: bigint): string {
  const whole = raw / 100n;
  const frac  = raw % 100n;
  return `${whole}.${String(frac).padStart(2, '0')} ${config.blockchain.tokenSymbol}`;
}

// Full address → "0x123456...abcd"
export function truncateAddress(addr: string): string {
  if (!addr || addr.length < 12) return addr;
  return `${addr.slice(0, 8)}...${addr.slice(-6)}`;
}

// Unix bigint timestamp → "2m ago"
export function timeAgo(ts: bigint): string {
  const diff = BigInt(Math.floor(Date.now() / 1000)) - ts;
  if (diff < 60n)    return `${diff}s ago`;
  if (diff < 3600n)  return `${diff / 60n}m ago`;
  if (diff < 86400n) return `${diff / 3600n}h ago`;
  return `${diff / 86400n}d ago`;
}

// Unix bigint timestamp → locale date string (for title= tooltip)
export function fullDate(ts: bigint): string {
  return new Date(Number(ts) * 1000).toLocaleString();
}
